// extracted by mini-css-extract-plugin
export default {"report_row":"ReportRow_report_row__sVtyb","report_row__item":"ReportRow_report_row__item__2t8Yn","report_row__data":"ReportRow_report_row__data__6cNOG"};